export default __webpack_public_path__ + "static/media/color3.38c3206f.jpg";